import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(customer_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `customer/query/containers_intermediated/${customer_id}/list_containers/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainers(customer_id, agro_exporter_process_id, params) {
    return RequesterV1.get(
      `customer/query/containers_intermediated/${customer_id}/list_containers/${agro_exporter_process_id}`,
      { params }
    );
  }
};
